import { BiFolderMinus } from "react-icons/bi";
import { useState, useEffect } from "react";
//import { connection } from "utils/apiConnection.ts";
import { FiEdit, FiExternalLink } from "react-icons/fi";
import { GrInstagram } from "react-icons/gr";
import { BsWhatsapp } from "react-icons/bs";
import { AiOutlineStop } from "react-icons/ai";
import { addCommas, removeCommas } from "@persian-tools/persian-tools";
import { RiDeleteBack2Line } from "react-icons/ri";
import { RiOrderPlayLine } from "react-icons/ri";
import BtnPage from "./BtnPage";
import { NavLink } from "react-router-dom";
import product1 from "assets/images/product1.png";
import { MdBlock } from "react-icons/md";
import { CgUnblock } from "react-icons/cg";
import logoGM from "assets/images/sitelogo.svg";
import toast from "react-hot-toast";

import Swal from "sweetalert2";

import "./Store.scss";
import ReactTooltip from "react-tooltip";

export default function StoreList({
  informationStore,
  setInformationStore,
  val,
  index,
  setSelectedItem,
  stopHandler,
  deletepHandler,
  showEditStoreModal,
  setShowEditStoreModal,
}) {
  const [businessId, setBusinessId] = useState("");
  const [activeBusiness, setActiveBusiness] = useState();

  useEffect(() => {
    setActiveBusiness(val.status);
    setBusinessId(val.id);
  }, [val]);

  useEffect(() => ReactTooltip.rebuild());
  // console.log("val=>", val);
  return (
    <div
      className={`w-100  ${val.status == "0" ? "bg-active" : "bg-disable"}`}
      style={{
        borderRadius: " 10px",
      }}
    >
      <div className="row flex-wrap secondry">
        <div className="BlueCol col-12 col-sm-6 col-md-4 col-lg-3">
          <p className="d-flex justify-content-center align-items-center blueRow">
            نام
          </p>
          {val.title ? (
            <p className="d-flex justify-content-center align-items-center nameRow">
              {val.title}
            </p>
          ) : (
            <p className="d-flex justify-content-center align-items-center nameRow">
              ---
            </p>
          )}
        </div>
        <div className="BlueCol col-12 col-sm-6 col-md-4 col-lg-2">
          <p className="d-flex justify-content-center align-items-center blueRow">
            نوع
          </p>
          {val.type == "0" ? (
            <p className="d-flex justify-content-center align-items-center nameRow">
              تامین کننده اصلی{" "}
            </p>
          ) : (
            <p className="d-flex justify-content-center align-items-center nameRow">
              تامین کننده عادی{" "}
            </p>
          )}
        </div>
        <div className="BlueCol col-12 col-sm-6 col-md-4 col-lg-2">
          <p className=" d-flex justify-content-center align-items-center blueRow">
            توضیحات
          </p>
          {val.description ? (
            <p
              className="d-flex justify-content-center align-items-center nameRow responsiveRow"
              style={{}}
            >
              {val.description}
            </p>
          ) : (
            <p className="d-flex justify-content-center align-items-center nameRow">
              ---
            </p>
          )}
        </div>
        <div className="BlueCol col-12 col-sm-6 col-md-4 col-lg-1">
          <p className="d-flex justify-content-center align-items-center blueRow">
            تصویر لوگو
          </p>
          <div className="d-flex justify-content-center align-items-center nameRow">
            {val.url ? (
              <img
                style={{
                  width: "55px",
                  borderRadius: "50%",
                  height: "50px",
                  marginTop: "5px",
                }}
                src={`http://marketgroup.tatdemo.ir//${val.url}`}
              />
            ) : (
              <img
                style={{
                  width: "55px",
                  borderRadius: "50%",
                  height: "50px",
                  marginTop: "5px",
                }}
                src={logoGM}
              />
            )}
          </div>
        </div>

        <div className="BlueCol col-12 col-sm-6 col-md-4 col-lg-2">
          <p className="d-flex justify-content-center align-items-center blueRow">
            موبایل
          </p>
          {val.mobile ? (
            <p className="d-flex justify-content-center align-items-center nameRow">
              {val.mobile}
            </p>
          ) : (
            <p className="d-flex justify-content-center align-items-center nameRow">
              ---{" "}
            </p>
          )}
        </div>
        <div className="BlueCol col-12 col-sm-6 col-md-4 col-lg-2">
          <p className="d-flex justify-content-center align-items-center blueRow">
            آدرس
          </p>
          {val.address ? (
            <p
              className="d-flex justify-content-center align-items-center nameRow responsiveRow w-100"
              style={{}}
            >
              {val.address}
            </p>
          ) : (
            <p className="d-flex justify-content-center align-items-center nameRow ">
              ---
            </p>
          )}
        </div>

        <div className="BlueCol col-12 col-sm-6 col-md-4 col-lg-2">
          <p className="d-flex justify-content-center align-items-center blueRow">
            عملیات{" "}
          </p>
          <div className="d-flex justify-content-center align-items-center nameRow">
            <p
              className="tlg"
              data-bs-toggle="modal"
              data-bs-target="#EditStoreModal"
              onClick={() => {
                setSelectedItem(val);
                setShowEditStoreModal(true);
              }}
            >
              <h4 data-tip="ویرایش فروشگاه" data-for="gm-tooltip">
                <FiEdit className="tlg1" />
              </h4>
              {/* <ReactTooltip /> */}
            </p>
            <p className="tlg">
              {val.status == "0" ? (
                <NavLink to={`/shop/${val.id}`} target="_blank">
                  <h4 data-tip="ویترین فروشگاه" data-for="gm-tooltip">
                    <FiExternalLink
                      className="tlg1"
                      style={{ color: "white" }}
                    />
                  </h4>
                </NavLink>
              ) : (
                <NavLink to={`/shop/${val.id}`} target="_blank">
                  <h4 data-tip="ویترین فروشگاه" data-for="gm-tooltip">
                    <FiExternalLink
                      className="tlg1"
                      style={{ color: "rgb(31, 29, 29)" }}
                    />
                  </h4>
                </NavLink>
              )}
            </p>

            <p
              className="tlg"
              onClick={() => {
                setBusinessId(val.id);
                console.log("ee", val.id);

                Swal.fire({
                  title: "آیا از حذف فروشگاه مطمئن هستید؟",
                  imageUrl: logoGM,
                  showDenyButton: true,
                  confirmButtonText: "بله",
                  denyButtonText: `خیر`,
                }).then((result) => {
                  if (result.isConfirmed) {
                    deletepHandler(businessId);
                    //navigate("/");
                    // Swal.fire("اتمام فروش باموفقت ثبت شد", "", "success");
                  }
                });
              }}
            >
              <h4 data-tip="حذف فروشگاه" data-for="gm-tooltip">
                <RiDeleteBack2Line className="tlg1" />
              </h4>
              <ReactTooltip />
            </p>
            {val && val.status == "0" ? (
              <p
                className="tlg"
                onClick={() => {
                  console.log("ee", val.id);
                  console.log("st", val.status);

                  // setActiveBusiness(val.status);
                  // setBusinessId(val.id);
                  Swal.fire({
                    title: "آیا از توقف فروشگاه مطمئن هستید؟",
                    imageUrl: logoGM,
                    showDenyButton: true,
                    confirmButtonText: "بله",
                    denyButtonText: `خیر`,
                  }).then((result) => {
                    if (result.isConfirmed) {
                      stopHandler(businessId, activeBusiness);

                      //navigate("/");
                      // Swal.fire("اتمام فروش باموفقت ثبت شد", "", "success");
                    }
                  });
                }}
              >
                <h4 data-tip="توقف فروشگاه">
                  <AiOutlineStop className="tlg1" />
                </h4>
                <ReactTooltip />
              </p>
            ) : (
              <p
                className="tlg"
                onClick={() => {
                  console.log("ee", val.id);
                  console.log("st", val.status);

                  setBusinessId(val.id);

                  Swal.fire({
                    title: "آیا از فعال شدن فروشگاه مطمئن هستید؟",
                    showDenyButton: true,
                    imageUrl: logoGM,
                    confirmButtonText: "بله",
                    denyButtonText: `خیر`,
                  }).then((result) => {
                    if (result.isConfirmed) {
                      stopHandler(businessId, activeBusiness);

                      //navigate("/");
                      // Swal.fire("اتمام فروش باموفقت ثبت شد", "", "success");
                    }
                  });
                }}
              >
                <h4 data-tip=" فعال شدن فروشگاه ">
                  <CgUnblock className="tlg1" />
                </h4>
                <ReactTooltip />
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
